export default "/assets/images/problem-solved-09.690e22c1033d24bc.webp";